import { RMap } from "../../collections";
import { ParameterSetImpl } from "./ParameterSetImpl";
import { makeImmutable } from "../../core/makeImmutable";
import { ScheduleParameterMultiSet } from "../ParameterMultiSet";
export class ScheduleParameterSet {
    constructor(impl) {
        this.impl = impl;
        makeImmutable(this);
    }
    static fromRMap(parameterValues) {
        return new ScheduleParameterSet(new ParameterSetImpl({
            parameterValues,
            valueComparator: (a, b) => a === b,
        }));
    }
    static matchingFulfillmentTimes(schedules, fulfillmentTimes) {
        const scheduleStatus = RMap.fromIterable(schedules.objects.mapOptional((schedule) => {
            const matchesSchedule = (fulfillmentTime) => schedule.includes(fulfillmentTime);
            if (fulfillmentTimes.every(matchesSchedule)) {
                return [schedule, true];
            }
            if (fulfillmentTimes.some(matchesSchedule)) {
                return null;
            }
            return [schedule, false];
        }));
        return ScheduleParameterSet.fromRMap(scheduleStatus);
    }
    static matchingFulfillmentTime(schedules, fulfillmentTime) {
        const scheduleStatus = RMap.fromIterable(schedules.objects.map((schedule) => {
            if (schedule.includes(fulfillmentTime)) {
                return [schedule, true];
            }
            return [schedule, false];
        }));
        return ScheduleParameterSet.fromRMap(scheduleStatus);
    }
    get isEmpty() {
        return this.impl.isEmpty;
    }
    static empty() {
        return ScheduleParameterSet.fromRMap(RMap.empty());
    }
    unify(other) {
        const result = this.impl.unify(other.impl);
        switch (result.type) {
            case "success":
                return {
                    type: "success",
                    matchingParameters: new ScheduleParameterMultiSet(result.matchingParameters),
                    value: new ScheduleParameterSet(result.value),
                };
            case "failure":
                return {
                    type: "failure",
                    matchingParameters: new ScheduleParameterMultiSet(result.matchingParameters),
                    incompatibleParameters: new ScheduleParameterMultiSet(result.incompatibleParameters),
                };
        }
    }
    union(other) {
        const result = this.impl.union(other.impl);
        if (result === null) {
            return null;
        }
        return new ScheduleParameterSet(result);
    }
    get values() {
        return this.impl.parameterValues;
    }
    get schedules() {
        return this.values.keys;
    }
}
